import { Box, Circle, Flex, Heading, Text } from '@chakra-ui/react';
import { titleCase } from 'title-case';

const ReviewCard = ({ review }) => {
  const { first_name, comment, response_received_at } = review;
  const date = new Date(response_received_at);
  return comment && first_name && response_received_at ? (
    <Box
      p={5}
      pb={10}
      background="white"
      w={360}
      h={200}
      rounded="lg"
      shadow="3px 3px 12px 3px rgba(0,0,0,0.24)
    "
    >
      <Flex align="center">
        <Circle size="50px" border="3px solid #335eea" mr={5} color="blue.500" fontSize="md" fontWeight={500}>
          10/10
        </Circle>
        <Flex direction="column">
          <Heading fontSize="xl">{titleCase(first_name.toLowerCase())}</Heading>
          <Text fontSize="md">{`${date.getUTCMonth() + 1}/${date.getDate()}/${date.getUTCFullYear()}`}</Text>
        </Flex>
      </Flex>
      <Text fontSize="md" pt={4}>
        {comment.length > 150 ? `${comment.slice(0, 150)}...` : comment}
      </Text>
    </Box>
  ) : null;
};

export default ReviewCard;
